


























import Vue from "vue";

export default Vue.extend({
  props: {
    downloadPercentage: {
      type: Number,
      required: true,
    },
    isSavingReport: {
      type: Boolean,
      default: false,
    },
    isGenerateReport: {
      type: Boolean,
      default: false,
    },
    isDownloadReport: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    childDownloadPercentage: {
      get() {
        return (this as any).downloadPercentage;
      },
      set(val) {
        return this.$emit("update:downloadPercentage", val);
      },
    },
  },
});
